import Icon from "@ant-design/icons";

const SearchEmptyIconSVG = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M16.7989 56.7825C27.5218 56.7825 34.8854 61.7345 40.0523 61.7345C45.2192 61.7345 56.0708 59.0864 56.0708 37.8952C56.0708 16.7039 41.4723 13.5929 35.7892 13.5929C9.17649 13.5929 -2.1913 56.7825 16.7989 56.7825Z"
      fill="#F7F6F5"
    />
    <path
      d="M58.2549 33.8348C58.198 33.1665 57.7679 32.6177 57.1324 32.4025L51.9765 30.6565L56.996 24.8977C57.3292 24.5155 57.4686 24.01 57.3786 23.511C57.2884 23.012 56.981 22.5872 56.5351 22.3456L50.0593 18.8371C49.6362 18.6079 49.1077 18.7649 48.8783 19.188C48.6491 19.611 48.8063 20.1397 49.2292 20.3689L55.616 23.8292L50.2669 29.9661L33.3714 20.8119L36.5064 17.2152C36.8672 17.3477 37.2568 17.4199 37.6628 17.4199C38.9237 17.4199 40.0242 16.7226 40.6006 15.6939L45.4417 18.3168C45.5737 18.3883 45.7157 18.4222 45.8559 18.4222C46.1653 18.4222 46.4649 18.257 46.6227 17.9658C46.8519 17.5428 46.6947 17.0141 46.2717 16.7849L41.0259 13.9428C40.9668 12.1384 39.4815 10.6885 37.663 10.6885C35.8071 10.6885 34.2972 12.1983 34.2972 14.0542C34.2972 14.8713 34.5902 15.6211 35.0761 16.2047L32 19.7339L26.5501 13.4816C26.0355 12.8912 25.1954 12.7394 24.5065 13.1124L22.3762 14.2666C22.1266 12.2926 20.4381 10.7606 18.3974 10.7606C16.1854 10.7606 14.3858 12.5603 14.3858 14.7724C14.3858 15.9954 14.9367 17.0918 15.8026 17.8282L7.46482 22.3456C7.01903 22.5872 6.71169 23.0119 6.62144 23.511C6.53143 24.01 6.67081 24.5155 7.00405 24.8976L12.0234 30.6564L6.86757 32.4022C6.23211 32.6175 5.802 33.1663 5.74508 33.8346C5.68817 34.5029 6.0192 35.1167 6.60902 35.4362L12.6636 38.7166V46.3052C12.6636 46.7863 13.0535 45.434 13.5348 45.434C14.016 45.434 14.4059 47.2069 14.4059 46.7258V39.6605L22.8766 44.2499C23.2379 44.4457 23.6411 44.5452 24.0457 44.5452C24.3103 44.5452 24.5757 44.5026 24.8303 44.4164L31.129 42.2838V59.6161L14.7771 50.7563C14.5482 50.6323 14.406 50.3935 14.406 50.133V46.3052C14.406 45.8241 14.016 45.434 13.5348 45.434C13.0535 45.434 12.6636 45.8241 12.6636 46.3052L12.6637 50.133C12.6637 51.0335 13.1554 51.8592 13.9471 52.2881L30.8325 61.437C31.1981 61.6351 31.5992 61.7341 32.0002 61.7341C32.4013 61.7341 32.8024 61.635 33.168 61.437L50.0534 52.2881C50.8449 51.8592 51.3367 51.0335 51.3367 50.133V38.7164L57.3912 35.4361C57.9807 35.1169 58.3118 34.5033 58.2549 33.8348ZM33.9258 27.0955C36.9752 27.9527 39.105 30.7647 39.105 33.9339C39.105 34.8164 38.9464 35.6729 38.633 36.4845L32 40.0783L25.367 36.4845C25.0537 35.6729 24.895 34.8164 24.895 33.9339C24.895 30.755 27.0329 27.9405 30.0942 27.0897C30.5576 26.9609 30.829 26.4806 30.7002 26.0172C30.5715 25.5536 30.0909 25.2824 29.6276 25.4111C25.8154 26.4707 23.1529 29.9754 23.1529 33.9339C23.1529 34.4113 23.1916 34.8825 23.2659 35.3462L15.3634 31.0645L32.0002 22.0505L48.6369 31.0646L40.7345 35.3463C40.8088 34.8826 40.8475 34.4114 40.8475 33.934C40.8475 29.9876 38.1952 26.4858 34.3975 25.4183C33.9343 25.288 33.4533 25.5581 33.3232 26.0211C33.1926 26.4843 33.4625 26.9653 33.9258 27.0955ZM37.6628 12.431C38.558 12.431 39.2864 13.1592 39.2864 14.0544C39.2864 14.9496 38.558 15.678 37.6628 15.678C36.7677 15.678 36.0394 14.9496 36.0394 14.0544C36.0394 13.1592 36.7677 12.431 37.6628 12.431ZM18.3974 12.5031C19.6487 12.5031 20.6669 13.5212 20.6669 14.7726C20.6669 16.0239 19.6487 17.0421 18.3974 17.0421C17.1461 17.0421 16.1281 16.024 16.1281 14.7726C16.1281 13.5212 17.1461 12.5031 18.3974 12.5031ZM17.7828 18.7372C17.9832 18.7682 18.1885 18.7843 18.3974 18.7843C20.021 18.7843 21.4212 17.8143 22.052 16.424L25.2794 14.6755L30.6284 20.8121L13.7329 29.9663L8.3838 23.8295L17.7828 18.7372ZM24.2714 42.7665C24.0851 42.8297 23.8791 42.8119 23.7065 42.7183L13.9536 37.4342C13.951 37.4329 13.9484 37.4315 13.9458 37.4301L7.60234 33.9932L13.4538 32.0117L29.8299 40.8845L24.2714 42.7665ZM49.5941 50.1334C49.5941 50.3938 49.4518 50.6326 49.223 50.7567L32.8711 59.6164V42.2841L39.1698 44.4168C39.4244 44.503 39.6898 44.5456 39.9545 44.5456C40.3589 44.5456 40.7622 44.4459 41.1236 44.2502L49.5942 39.6609L49.5941 50.1334ZM40.2934 42.7183C40.1208 42.8119 39.9148 42.8297 39.7285 42.7665L34.1701 40.8845L50.5462 32.0117L56.3977 33.9932L40.2934 42.7183Z"
      fill="url(#paint0_linear_930_1982)"
    />
    <path
      d="M38.5147 51.5929L36.5163 52.6757C36.0933 52.9049 35.9363 53.4336 36.1654 53.8566C36.3232 54.1477 36.6228 54.3129 36.9322 54.3129C37.0723 54.3129 37.2146 54.279 37.3464 54.2076L39.3448 53.1248C39.7678 52.8957 39.9249 52.367 39.6957 51.9439C39.4665 51.5209 38.9381 51.3637 38.5147 51.5929Z"
      fill="url(#paint1_linear_930_1982)"
    />
    <path
      d="M21.7434 9.60148C21.9136 9.77153 22.1366 9.85667 22.3595 9.85667C22.5824 9.85667 22.8054 9.77164 22.9755 9.60148L23.6942 8.88286L24.4128 9.60148C24.5829 9.77153 24.8059 9.85667 25.0288 9.85667C25.2517 9.85667 25.4747 9.77164 25.6449 9.60148C25.9851 9.26128 25.9851 8.70968 25.6449 8.36959L24.9262 7.65085L25.6449 6.93211C25.9851 6.59191 25.9851 6.04031 25.6449 5.70022C25.3046 5.36002 24.7531 5.36002 24.4129 5.70022L23.6943 6.41884L22.9756 5.70022C22.6353 5.36002 22.0838 5.36002 21.7436 5.70022C21.4034 6.04043 21.4034 6.59203 21.7436 6.93211L22.4624 7.65085L21.7436 8.36959C21.4032 8.70968 21.4032 9.26128 21.7434 9.60148Z"
      fill="url(#paint2_linear_930_1982)"
    />
    <path
      d="M47.5334 15.308C47.7036 15.4781 47.9266 15.5632 48.1495 15.5632C48.3724 15.5632 48.5954 15.4782 48.7656 15.308L49.4842 14.5894L50.2028 15.308C50.373 15.4781 50.596 15.5632 50.8189 15.5632C51.0418 15.5632 51.2648 15.4782 51.4349 15.308C51.7751 14.9678 51.7751 14.4162 51.4349 14.0761L50.7162 13.3574L51.4349 12.6387C51.7751 12.2985 51.7751 11.7469 51.4349 11.4068C51.0946 11.0666 50.5431 11.0666 50.2029 11.4068L49.4843 12.1254L48.7657 11.4068C48.4254 11.0666 47.8739 11.0666 47.5337 11.4068C47.1935 11.747 47.1935 12.2986 47.5337 12.6387L48.2524 13.3574L47.5337 14.0761C47.1932 14.4162 47.1932 14.9678 47.5334 15.308Z"
      fill="url(#paint3_linear_930_1982)"
    />
    <path
      d="M42.724 9.85605C44.8168 9.85605 46.5194 8.15352 46.5194 6.06083C46.5193 3.96804 44.8167 2.2655 42.724 2.2655C40.6314 2.2655 38.9287 3.96804 38.9287 6.06083C38.9287 8.15352 40.6312 9.85605 42.724 9.85605ZM42.724 4.00776C43.856 4.00776 44.7771 4.92872 44.7771 6.06083C44.7771 7.19284 43.856 8.11379 42.724 8.11379C41.592 8.11379 40.671 7.19284 40.671 6.06083C40.671 4.92872 41.592 4.00776 42.724 4.00776Z"
      fill="url(#paint4_linear_930_1982)"
    />
    <path
      d="M31.9153 37.1788C32.7546 37.1788 33.5467 36.9005 34.147 36.3944C34.5147 36.0842 34.5615 35.5346 34.2513 35.1669C33.9413 34.799 33.3917 34.7523 33.0238 35.0625C32.7416 35.3005 32.3378 35.4367 31.9152 35.4367L31.9094 35.4367C31.4846 35.4354 31.0793 35.2966 30.7972 35.0558C30.6331 34.9158 30.432 34.8474 30.2321 34.8474C29.986 34.8474 29.7414 34.9511 29.5692 35.1529C29.2568 35.5188 29.3003 36.0688 29.6661 36.3811C30.2659 36.8931 31.0609 37.1765 31.9044 37.1791C31.908 37.1788 31.9117 37.1788 31.9153 37.1788Z"
      fill="url(#paint5_linear_930_1982)"
    />
    <path
      d="M28.2162 32.2678H28.2081C27.7265 32.2607 27.3385 32.6519 27.335 33.1329C27.3317 33.614 27.723 34.0067 28.2041 34.01H28.2103C28.6885 34.01 29.0779 33.624 29.0813 33.145C29.0847 32.6639 28.6974 32.2712 28.2162 32.2678Z"
      fill="url(#paint6_linear_930_1982)"
    />
    <path
      d="M35.6217 33.9921C35.6247 33.9927 35.6279 33.993 35.6309 33.9936C35.656 33.9985 35.6814 34.0025 35.7072 34.0052C35.7156 34.006 35.724 34.006 35.7324 34.0066C35.7518 34.008 35.7712 34.0098 35.7911 34.01H35.7972C35.8272 34.01 35.8568 34.0084 35.8861 34.0054C36.3259 33.9614 36.6693 33.5902 36.6693 33.1387C36.6693 32.6932 36.3346 32.3265 35.9031 32.2746C35.8992 32.2741 35.8954 32.2732 35.8914 32.2728C35.8716 32.2707 35.8512 32.2701 35.8309 32.2693C35.8216 32.269 35.8125 32.2678 35.8031 32.2677H35.7986C35.7985 32.2677 35.7983 32.2677 35.7981 32.2677H35.795H35.7899C35.7895 32.2677 35.7892 32.2677 35.7889 32.2677C35.3107 32.2677 34.9253 32.6538 34.9219 33.1328C34.919 33.5559 35.2214 33.9104 35.6217 33.9921Z"
      fill="url(#paint7_linear_930_1982)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_930_1982"
        x1="5.73877"
        y1="36.2113"
        x2="58.2612"
        y2="36.2113"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_930_1982"
        x1="36.0601"
        y1="52.9002"
        x2="39.8011"
        y2="52.9002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_930_1982"
        x1="21.4883"
        y1="7.65087"
        x2="25.9001"
        y2="7.65087"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_930_1982"
        x1="47.2783"
        y1="13.3574"
        x2="51.6901"
        y2="13.3574"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_930_1982"
        x1="38.9287"
        y1="6.06078"
        x2="46.5194"
        y2="6.06078"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_930_1982"
        x1="34.4565"
        y1="36.0132"
        x2="29.3606"
        y2="36.0132"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_930_1982"
        x1="27.335"
        y1="33.1389"
        x2="29.0813"
        y2="33.1389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_930_1982"
        x1="34.9219"
        y1="33.1388"
        x2="36.6693"
        y2="33.1388"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
    </defs>
  </svg>
);
const SearchEmptyIcon = (props) => (
  <Icon component={() => SearchEmptyIconSVG(props)} {...props} />
);

export default SearchEmptyIcon;
